export default __webpack_public_path__ + "static/media/marker-ecology.bea6028a.svg";